import MixerInputs from "./MixerInputs";

export default MixerInputs;